import React, {useState, useEffect} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import { useVsiAppContext} from "../../../../stores/VsiApp";
import {VsiBubble, VsiH4,} from "../../../../styled/App.styled";
import {storageSummaryDefs} from "../../../../utils/gridColumnDefs/storage/allUnits";
import {getReport} from "../../../../utils/Verbs";
import Grid from "../../../../components/Grid";
import {useTitleFromComponent} from "../../../../utils/hooks";
import {Card} from "reactstrap";

export default function StorageGroupSummary({title}) {
    const [searchParams] = useSearchParams();
    const [summaryData, setSummaryData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    let navigate = useNavigate();
    const { theme, client, periodId, getAccessTokenSilently } = useVsiAppContext();

    useTitleFromComponent(`${searchParams.get('device_name')} / ${title}`);
    const getSummary = async function () {
        const device_name = searchParams.get('device_name');
        const route = `/api/v6/report/device_storage_group_summary_proc?client_id=${client.clientId}&period_id=${periodId}&device_name=${device_name}`;
        try {
            const token = await getAccessTokenSilently();
            const data = await getReport(route, null, token);
            setSummaryData(data?.data.recordset || []);
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    };

    const onRowClick = (e) => {
        navigate(`/reports/storage/device/device-trends?device_name=${encodeURI(searchParams.get("device_name"))}&wwn=${encodeURI(e.data.wwn)}&period_id=${e.data.period_id}&metric=by_volume&volume=${e.data.volume_name}`)
    }

    useEffect(() => {
        getSummary();
    }, [searchParams]);

    return <Card className={`report-card p-2 nav-card-${theme}`}>
        <VsiH4>Storage Group Summary - {searchParams.get('device_name')}</VsiH4>
        <VsiBubble>
            <Grid data={summaryData}
                  columnDefs={storageSummaryDefs}
                  isLoading={isLoading}
                  rowDoubleClicked={onRowClick}/>
        </VsiBubble>
    </Card>
}
